import backendURLs from '~/misc/backendURLs';

export default (axios, params) => {
  return axios
    .get(`${backendURLs.selections}/search`, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
